import { Field, Formik } from "formik";
import React from "react";
import { Form, FormGroup, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { ReduxState } from "../../../../../redux";
import { formikInput } from "../../../../../utils/utils";
import PopoverHelp from "../../../../Docuclipper/PopoverHelp";
import { LoadingTrackedButton } from "../../../../Docuclipper/TrackedButton";
import { downloadSpreadsheetHelper } from "./utils";

type Props = {};
export const IifOptions: React.FC<Props> = ({}) => {
  const [loading, setLoading] = React.useState(false);

  const dispatch = useDispatch();
  const { job } = useSelector((state: ReduxState) => state.JobData);

  const { downloadOptions } = useSelector(
    (state: ReduxState) => state.TransactionManager
  );
  const { selectedDocumentIds, selectedFieldNames } = downloadOptions;

  const { selectedL1: l1, selectedL2: l2 } = useSelector(
    (state: ReduxState) => state.TagLevel
  );
  //   const { selectedDocumentId } = useSelector(
  //     (state: ReduxState) => state.TransactionManager
  //   );
  const onExport = ({
    accountId,
    bankId,
    accountType,
    fromAccount,
    useCategoryAsDestination,
  }) => {
    return downloadSpreadsheetHelper(
      job,
      l1,
      l2,
      "FieldsToExcel1",
      "iif",
      {
        accountId,
        bankId,
        accountType,
        fromAccount,
        useCategoryAsDestination,
        getTotals: false,
      },
      selectedDocumentIds,
      selectedFieldNames,
      [],
      [
        {
          field: "fieldName",
          operator: "equals",
          value: "bankMode",
        },
      ],
      "date",
      "asc"
    );
  };
  const onSubmit =
    (format: "iif" | "iif") =>
    (
      { accountId, bankId, accountType, fromAccount, useCategoryAsDestination },
      { resetForm }
    ) => {
      setLoading(true);
      onExport({
        accountId,
        bankId,
        fromAccount,
        accountType,
        useCategoryAsDestination,
      })
        .then(() => {
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    };

  return (
    <Formik
      initialValues={{
        accountId: "",
        bankId: "",
        accountType: "checking",
        fromAccount: "",
        useCategoryAsDestination: true,
      }}
      validationSchema={Yup.object().shape({
        accountId: Yup.string().required("Source account is required"),
        fromAccount: Yup.string().when("useCategoryAsDestination", {
          is: false,
          then: Yup.string().required("Destination account is required"),
          otherwise: Yup.string().notRequired(),
        }),
      })}
      onSubmit={onSubmit("iif")}
    >
      {({ submitForm, values, setFieldValue }) => (
        <>
          <FormGroup>
            <Form.Label>
              <strong>Source Account</strong>
            </Form.Label>
            <PopoverHelp header="" id="iifFromAccountHelp" placement="bottom">
              The name of the account assigned to the transaction. Must match
              exactly with an account name in QuickBooks.
            </PopoverHelp>
            <Field name="accountId" type="text" component={formikInput}></Field>
          </FormGroup>

          <FormGroup>
            <Form.Label>
              <strong>Destination Account Type</strong>
            </Form.Label>
            <div>
              <div className="d-flex align-items-center">
                <Form.Check
                  type="radio"
                  id="useCategoryAsDestination"
                  name="useCategoryAsDestination"
                  label="Use Category as Destination Account"
                  checked={values.useCategoryAsDestination}
                  onChange={() =>
                    setFieldValue("useCategoryAsDestination", true)
                  }
                />
                <PopoverHelp header="" id="iifCategoryHelp" placement="bottom">
                  When using categories, the category names must match exactly
                  with account names in QuickBooks.
                </PopoverHelp>
              </div>
              <Form.Check
                type="radio"
                id="useCustomDestination"
                name="useCategoryAsDestination"
                label="Use Custom Destination Account"
                checked={!values.useCategoryAsDestination}
                onChange={() =>
                  setFieldValue("useCategoryAsDestination", false)
                }
              />
            </div>
          </FormGroup>

          {!values.useCategoryAsDestination && (
            <FormGroup>
              <Form.Label>
                <strong>Destination Account</strong>
              </Form.Label>
              <PopoverHelp header="" id="iifFromAccountHelp" placement="bottom">
                The income or expense account to which you assigned the
                transaction. Must match exactly with an account name in
                QuickBooks.
              </PopoverHelp>
              <Field
                name="fromAccount"
                type="text"
                component={formikInput}
              ></Field>
            </FormGroup>
          )}

          <Row className="justify-content-end mx-1">
            <LoadingTrackedButton
              isLoading={loading}
              className="btn-save-iif justify-content-center m-2"
              // disabled={anyFileUploading}
              variant="primary"
              onClick={() => {
                submitForm();
              }}
            >
              Download IIF
            </LoadingTrackedButton>
          </Row>

          {/* <FormGroup>
            <Form.Label>
              <strong>Statement Year</strong>
            </Form.Label>
            <Field name="year" type="text" component={formikInput}></Field>
          </FormGroup> */}
        </>
      )}
    </Formik>
  );
};
export default IifOptions;
